import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=7e67bfb8&scoped=true&"
import script from "./scoreDialog.vue?vue&type=script&lang=js&"
export * from "./scoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=7e67bfb8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e67bfb8",
  null
  
)

export default component.exports